import { FeatureTogglePort } from '@otto-ec/eprivacy-shared'

export const USE_EVENT_TRACKING_FOR_CB_VIEW_KEY = 'cb_track_view_by_event'
export function useEventTrackingForCbView(
  featureToggleTestAdapter: FeatureTogglePort
): boolean {
  return featureToggleTestAdapter(USE_EVENT_TRACKING_FOR_CB_VIEW_KEY, false)
}
